import React, { useState, useEffect } from "react";
import Card from "./components/card";
import { Col, Row, Space } from "antd";
import boxStar from "./images/box_star.svg";
import handShake from "./images/handshake.svg";
import handShakeHeart from "./images/handshake_heart.svg";
import { useMediaQuery } from "react-responsive";

const Cards = [
  {
    icon: boxStar,
    title: "420 000+",
    text: "tiek 2022 m. išsiuntėme jūsų siuntų",
  },
  {
    icon: handShake,
    title: "4 000+",
    text: "tiek verslo klientų 2022 m. patikėjo savo siuntas mums",
  },
  {
    icon: handShakeHeart,
    title: "120 000+",
    text: "tiek privačių klientų 2022 m. patikėjo savo siuntas mums",
  }
]

const MainHeader = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  return (
    <>
      <div style={{
        textAlign: "center",
        margin: isMobileScreen ? "" : "100px 100px 50px 100px",
        padding: isMobileScreen ? "15px" : "",
      }}>
        <h1 className="alsendo" style={{ marginBottom: 30 }}>
          {"Apie mus"}
        </h1>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 29,
          }}
        >
          <h3 className="alsendo" style={{ maxWidth: 710 }}>
            {
              "Esame patikimas tavo siuntų siuntimo partneris nuo 2014 m."
            }
          </h3>
        </div>
        <Row gutter={isMobileScreen ? [16, 16] : [32, 32]}>
          {Cards.map((card) => (
            <Col span={24} md={{ span: 12 }} xl={{ span: 8 }} key={card.title}>
              <Card info={card} />
            </Col>
          ))}
        </Row>
        <h3 className="alsendo mt-4" style={{
          marginTop: 30,
        }}
          style={{ color: '#6D3ADF'}}>

          {"Patikėk savo siuntas mums!"}
        </h3>
      </div>
    </>
  );
};

export default MainHeader;
